module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAV1BMVEUAAAB2kft2jfZ2kPp1kfp2kPt2j/x2kfp2kfp0kPptie11kfp2kfp2kPp2kPp1kPp2kPt0kPpyjflagP91kPp1kPp1kPt0kfl0kfl2kfp1kftyjfZ2kfqoIIxLAAAAHHRSTlMAfxf71ZEt9phSDu/hzsO/dGYlBuujg20/p4c4julZLQAAAJNJREFUGNN9kEkWgyAQRJtBRREI4JSE+58zNAHksbBWn+ri9QCPGrUZO2shUwjTQcubit1wFpIYN7vACgmdXo0p1wykMa9F9ub0BrBbNU8Em5sinxFmhCFC4Rmnri3hyxBHRJmiNbgCSvyTl/Uul8v/TccMx6UclOitoVyD357y9SbV1bS53MDSWh8PrdyhFKHwoB9SKxOVd+8krAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/index/images/appIcon/ZhiAnTong_2.png
// module id = ueqN
// module chunks = 57